export const isValidOrderInput = (value: string): boolean =>
  value.trim() === '' || (Number.isInteger(Number(value.trim())) && Number(value.trim()) >= 0)

const splitLines = (input: string): string[] =>
  input
    .split('\n')
    .map((s) => s.trim())
    .filter((s) => s.length > 0)

const DIGITS_ONLY = /^\d+$/

export const parseMccs = (input: string): { mccs: string[]; hasInvalid: boolean } => {
  const parts = splitLines(input)
  if (parts.length === 0) return { mccs: [], hasInvalid: false }
  const mccs: string[] = []
  let hasInvalid = false
  for (const part of parts) {
    if (DIGITS_ONLY.test(part) && part.length === 4) {
      mccs.push(part)
    } else {
      hasInvalid = true
    }
  }
  return { mccs, hasInvalid }
}

export const parseMids = (input: string): { mids: string[]; hasInvalid: boolean } => {
  const parts = splitLines(input)
  if (parts.length === 0) return { mids: [], hasInvalid: false }
  const mids: string[] = []
  let hasInvalid = false
  for (const part of parts) {
    if (DIGITS_ONLY.test(part)) {
      mids.push(part)
    } else {
      hasInvalid = true
    }
  }
  return { mids, hasInvalid }
}

export const buildPastedValue = (textarea: HTMLTextAreaElement, pasted: string): string => {
  const normalized = pasted.replace(/[,\s]+/g, '\n').replace(/^\n+|\n+$/g, '')
  const start = textarea.selectionStart ?? textarea.value.length
  const end = textarea.selectionEnd ?? textarea.value.length
  const before = textarea.value.slice(0, start)
  const after = textarea.value.slice(end)
  if (normalized === '') return before + after
  const leading = before.length > 0 && !before.endsWith('\n') ? '\n' : ''
  const trailing = after.length > 0 && !after.startsWith('\n') ? '\n' : ''
  return before + leading + normalized + trailing + after
}
